import Vue from "vue";
import Router from "vue-router";
import Search from "./views/Search.vue";
import Details from "./views/Details.vue";
import Results from "./views/Results";
import NotFound from "./views/NotFound";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "search",
      component: Search
    },
    {
      path: "/results",
      name: "results",
      component: Results
    },
    {
      path: "/car/:carId",
      name: "car",
      component: Details
    },
    {
      path: "/dealer/:dealerName",
      name: "dealerSearch",
      component: Search
    },
    {
      path: "/dealer/:dealerName/results",
      name: "dealerResults",
      component: Results
    },
    {
      path: "/dealer/:dealerName/car/:carId",
      name: "dealerDetails",
      component: Details
    },
    { path: "/not-found", name: "notFound", component: NotFound },
    { path: "*", redirect: "/not-found" }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});
